module.exports = __webpack_public_path__ + "img/h-1.34f7f41f.jpg";